require("@rails/ujs").start()

import 'jquery'
import 'bootstrap'

import 'common/src/components/footer'
import 'common/src/components/testimonials'

import 'common/src/site'